interface hoursMinutesDisplayProps {
  minutes: number
}

export const hoursMinutesDisplay = (props: hoursMinutesDisplayProps) => {
  const hours = Math.floor(props.minutes / 60)
  const minutes = props.minutes % 60

  switch (props.minutes) {
    case 1:
      return `${props.minutes} minute`
    default:
      if (props.minutes < 60) {
        return `${props.minutes} minutes`
      } else {
        return `${hours} ${hours > 1 ? 'hours' : 'hour'} ${minutes} ${
          minutes === 1 ? 'minute' : 'minutes'
        } `
      }
  }
}

interface hoursDisplayProps {
  minutes: number
}

export const hoursDisplay = (props: hoursDisplayProps) => {
  const hours = Math.floor(props.minutes / 60)

  if (props.minutes > 60) {
    return `${hours} Hours`
  } else {
    return `${hours} Hour`
  }
}

export default hoursMinutesDisplay
